export enum FilterTypeEnum {
  ROOMS_TYPE = 'rooms',
  LESSONS_TYPE = 'lessons',
  TESTS_TYPE = 'tests',
  EXAMINATION_TYPE = 'examination',
}



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/calendar/components/calendarfilter/components/filterbottonsblock/types.ts